import { FEATURES } from 'consts';
import { remotePropertiesStore } from 'state/store';
import { selectRemoteProperties } from 'state/selectors';
import { fetchMeetRemoteProperties } from './fetchMeetRemoteProperties';
import { getFullFeaturesList } from './getFullFeaturesList';

// Локальные ФФ доступны сразу, без ожидания remote properties.
remotePropertiesStore.setRemoteProperties(getFullFeaturesList(null));

export const isFeatureOn = (feature: FEATURES): boolean => {
    const remoteProperties = selectRemoteProperties();
    if (!remoteProperties) {
        return false;
    }
    return remoteProperties[feature] === true;
};

/** VCS_ACCESS_REQUEST_ENABLED действует только при включённом VCS_MODERATORS_ENABLED. */
export const isAccessRequestFeatureOn = (): boolean => {
    if (!isFeatureOn(FEATURES.VCS_MODERATORS_ENABLED)) {
        return false;
    }
    return isFeatureOn(FEATURES.VCS_ACCESS_REQUEST_ENABLED);
};

/** VCS_WEBINAR_ENABLED действует только при включённом VCS_MODERATORS_ENABLED. */
export const isWebinarFeatureOn = (): boolean => {
    if (!isFeatureOn(FEATURES.VCS_MODERATORS_ENABLED)) {
        return false;
    }
    return isFeatureOn(FEATURES.VCS_WEBINAR_ENABLED);
};

export const fetchFeatureFlags = async () => {
    const payload = await fetchMeetRemoteProperties();
    const list = payload ? getFullFeaturesList(payload) : getFullFeaturesList(null);
    remotePropertiesStore.setRemoteProperties(list);
};
